import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/server';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as serviceWorker from './common/serviceWorker';
import App, { browserHistory } from './App';
import { firebase } from './redux/firebase';
import { CreateUser, getDefinition } from './redux/actions/user';
import { getUserInstanceDetail, getRelationship } from './redux/actions/GraphQlActions';

// const root = createRoot(document.getElementById('root'));

// main component
ReactDOM.render(
  // NOTE: StrictMode will causes all UseEffects to run twice on mount!
  <StrictMode>
    <Provider store={store}>
      <CssBaseline />
      <App />
    </Provider>
    ,
  </StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();

// expose store when run in Cypress or locally
if (
  window.Cypress ||
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
) {
  window.store = store;
}

// Let E2E fixtures use the application's authenticated SDK. This bridge is
// absent outside Cypress and grants no additional backend permissions.
if (window.Cypress) {
  (window as any).__cypressFirebase = firebase;
  (window as any).__cypressTestActions = { CreateUser, getDefinition, getUserInstanceDetail, getRelationship,
    navigate: (path: string) => browserHistory.push(path) };
}
